<template>
  <v-menu offset-y bottom left attach="#top">
    <v-btn flat small slot="activator">
      <v-flex xs12 d-flex>
        <v-avatar
          size="32"
        >
          <img class="cover" :src="userpic">
        </v-avatar>
      </v-flex>
      <span class="hidden-xs-only">&nbsp;{{profile.name}}</span>
    </v-btn>
    <v-list>
      <v-subheader>действия</v-subheader>
      <v-list-tile @click="logout">
        <v-list-tile-content>
          <v-list-tile-title>Выход</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon>logout</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      
      <v-divider></v-divider>

      <v-subheader>выбрать пользователя</v-subheader>
      <v-list-tile
      v-for="item in profile.linked"
      :key="item.personid"
      @click="() => { switchUser(item.personid) }"
      :disabled="item.personid === profile.personid"
      >
        <v-list-tile-title>{{ item.name }}</v-list-tile-title>
      </v-list-tile>

    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'user-bar',
  data: () => ({
    userpic: ''
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    }
  },
  methods: {
    async fetch () {
      const { userpic } = await this.profile
      this.userpic = userpic ||
      `https://ui-avatars.com/api/?name=${(this.profile.name || '').replace(' ', '+')}&size=128`
    },
    async switchUser (personid) {
      try {
        await this.$store.dispatch('sioRequest', {
          topic: 'auth-switch-person',
          pl: { personid }
        })
        this.$router.go()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    logout () {
      this.$store.dispatch('logout')
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>

<style lang="css">
.cover {
  object-fit: cover;
}
</style>
